// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"_10PHz","primaryText":"u6_tq","secondaryText":"_2K4gi"};